var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { CustomComponent } from '../../utils/CustomComponent';
import { omitStyleProps } from '../../utils/props';
import { applyMargins } from '../../utils/tailwind';
import { ButtonInner } from './ButtonInner';
import { DEFAULT_SIZE, DEFAULT_VARIANT, buttonVariants } from './styles';
const BaseButton = (_a, ref) => {
    var { children, className, color, component = 'button', disabled, endIcon, fixedIcon = false, justifyContent, loading, size = DEFAULT_SIZE, startIcon, variant = DEFAULT_VARIANT } = _a, props = __rest(_a, ["children", "className", "color", "component", "disabled", "endIcon", "fixedIcon", "justifyContent", "loading", "size", "startIcon", "variant"]);
    const isDisabled = disabled || loading;
    return (_jsx(CustomComponent, Object.assign({ as: component, className: buttonVariants({
            fixedIcon,
            justifyContent,
            size,
            variant: isDisabled ? 'disabled' : variant,
            className: [applyMargins(props), className],
        }), disabled: isDisabled, ref: ref }, (component === 'button' ? { type: 'button' } : {}), { 
        /**
         * @todo width needs to be applied as style to ensure backward compatibility.
         * However, it should be removed in v6, because it prevents the use of TW w-* classes
         */
        style: {
            '--width': typeof props.width === 'number' ? `${props.width}px` : props.width,
        } }, omitStyleProps(props), { children: _jsx(ButtonInner, { color: color, disabled: isDisabled, endIcon: endIcon, loading: loading, size: size, startIcon: startIcon, variant: variant, children: children }) })));
};
export const Button = forwardRef(BaseButton);
